import { format } from 'date-fns';

import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import { AppointmentsConflicts } from '@atom/types/appointments';
import { WorkOrder } from '@atom/types/work';

import classes from './workOrderDetailEdit.module.css';

export interface Props {
  appointmentConflicts: AppointmentsConflicts[];
}

const AppointmentConflictError = ({ appointmentConflicts }: Props) => {
  const getWorkConflictName = (workOrder: WorkOrder) => {
    const plannedStartDate = format(
      new Date(workOrder?.plannedStartDate),
      'MM/dd/yyyy hh:mm a',
    );
    const dueDateTime = format(new Date(workOrder?.dueDate), 'hh:mm a');

    return `${plannedStartDate} - ${dueDateTime} ${workOrder?.name}`;
  };

  return (
    <div className={classes.errorContainer}>
      <Icon color={colors.brand.orange}>warning</Icon>
      <div className={classes.errorContent}>
        <div>This work conflicts with the following assignees' work:</div>
        {appointmentConflicts?.map(conflict => {
          const user = `${conflict?.user?.firstName} ${conflict?.user?.lastName}`;
          return (
            <div>
              <div className={classes.userName}>{user}</div>
              {conflict?.workOrders?.map(workOrder => {
                const content = getWorkConflictName(workOrder);
                return (
                  <div className={classes.workOrderRow}>
                    <div className={classes.bullet} />
                    <div>{content}</div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AppointmentConflictError;
